import { contentStateFromString } from "@utils/richText/converters";
import {
	NotificationArticlePayload,
	NotificationBase,
	NotificationCoursePayload,
	NotificationFollowerPayload,
	NotificationNewPostCommentPayload,
	NotificationNewPostLikePayload,
	NotificationNewPostSharePayload,
	NotificationPost,
	NotificationPostComment,
	NotificationPostPayload,
	TooshareNotification,
} from "./notification";

export function notificationFromDto(dto: NotificationDto): TooshareNotification {
	return {
		...dto,
		date: new Date(dto.date),
		...(dto.type === "NEW_POST_MENTION" ||
		dto.type === "NEW_POST_COMMENT" ||
		dto.type === "NEW_POST_LIKE" ||
		dto.type === "NEW_POST_SHARE"
			? {
					post: {
						id: dto.post.id,
						assetCount: dto.post.assetCount,
						text: dto.post.text ? contentStateFromString(dto.post.text) : undefined,
					},
				}
			: {}),
		...(dto.type === "NEW_POST_COMMENT"
			? {
					comment: { ...dto.comment, text: contentStateFromString(dto.comment.text) },
				}
			: {}),
	} as TooshareNotification;
}
export type NotificationDto = Omit<NotificationBase, "date"> & { date: string } & NotificationPayloadDto;

type WithPostDto<T extends { post: NotificationPost }> = Omit<T, "post"> & { post: NotificationPostDto };
type WithCommentDto<T extends { comment: NotificationPostComment }> = Omit<T, "comment"> & {
	comment: NotificationPostCommentDto;
};

export type NotificationPostPayloadDto = WithPostDto<NotificationPostPayload>;
export type NotificationNewPostLikePayloadDto = WithPostDto<NotificationNewPostLikePayload>;
export type NotificationNewPostSharePayloadDto = WithPostDto<NotificationNewPostSharePayload>;
export type NotificationNewPostCommentPayloadDto = WithCommentDto<WithPostDto<NotificationNewPostCommentPayload>>;

export type NotificationPayloadDto =
	| NotificationPostPayloadDto
	| NotificationCoursePayload
	| NotificationArticlePayload
	| NotificationFollowerPayload
	| NotificationNewPostLikePayloadDto
	| NotificationNewPostSharePayloadDto
	| NotificationNewPostCommentPayloadDto;

type NotificationPostDto = Omit<NotificationPost, "text"> & {
	text?: string;
};
type NotificationPostCommentDto = Omit<NotificationPostComment, "text"> & {
	text: string;
};
